import { useContext } from 'react';
import { css } from '@emotion/react';
import { CallRouteV1 } from '@frontend/api-call-route';
import { useTranslation } from '@frontend/i18n';
import { RadioCardField, Text, useFormField } from '@frontend/design-system';
import { STEP_OPTIONS } from './add-step-panel';
import { Step } from './atoms/step';
import { StepContext } from './provider';

export const SelectStep = ({
  onProceedClick,
  initialStep,
  stepOptions,
}: {
  initialStep?: string;
  stepOptions: typeof STEP_OPTIONS;
  onProceedClick: (type: CallRouteV1.Types.NodeType) => void;
}) => {
  const { t } = useTranslation('phone');

  const { isEditMode } = useContext(StepContext);

  const cardFieldProps = useFormField({
    type: 'radio',
    required: true,
    value: initialStep,
  });

  return (
    <Step
      title={isEditMode ? t('Change Step') : t('Add Step')}
      description={isEditMode ? t('Change this step in the call flow.') : t('Add the next step to the call flow.')}
      primaryButtonLabel={t('Continue')}
      primaryButtonDisabled={!cardFieldProps.value}
      onPrimaryButtonClick={() => {
        const value = cardFieldProps.value;
        if (CallRouteV1.Types.isNodeType(value)) {
          onProceedClick(value);
        }
      }}
    >
      {stepOptions.hoursAndAvailability.length > 0 && (
        <>
          <Text weight='bold'>{t('Hours and Availability')}</Text>
          <RadioCardField {...cardFieldProps} name='field1' css={cardFieldStyles}>
            {stepOptions.hoursAndAvailability.map((option) => (
              <RadioCardField.Option
                key={option.type}
                css={cardStyles}
                value={option.type}
                title={option.title}
                description={option.description}
                iconName={option.iconName}
              />
            ))}
            <span></span>
          </RadioCardField>
        </>
      )}

      <Text weight='bold'>{t('Direct Routing')}</Text>
      <RadioCardField {...cardFieldProps} name='field1' css={cardFieldStyles}>
        {stepOptions.directRouting.map((option) => (
          <RadioCardField.Option
            key={option.type}
            css={cardStyles}
            value={option.type}
            title={option.title}
            description={option.description}
            iconName={option.iconName}
          />
        ))}
      </RadioCardField>

      <Text weight='bold'>{t('Messaging and Information')}</Text>
      <RadioCardField {...cardFieldProps} name='field1' css={cardFieldStyles}>
        {stepOptions.messagingAndInformation.map((option) => (
          <RadioCardField.Option
            key={option.type}
            css={cardStyles}
            value={option.type}
            title={option.title}
            description={option.description}
            iconName={option.iconName}
          />
        ))}
      </RadioCardField>
    </Step>
  );
};
const cardStyles = css`
  flex: unset;
  width: 300px;
`;
const cardFieldStyles = css`
  div:first-child {
    display: flex;
    flex-wrap: wrap;
  }
`;
